import React, { useContext } from 'react';
import PosicoesContext from '../../../../../context/posicoes.context';
import './sericicultor.scss';
import { constantes } from '../../../../../constantes';
import { notify } from '../../../../../functions/notifications';

function Cultura() {
  const {
    temp, verificaCultura, input,
    setarInformacoes, setInput,
    inputsVerificacao: {
      culturaCertificada,
    }, setInputsVerificacao,
  } = useContext(PosicoesContext);

  return (
    <div id="sericicultura">
      <div className="separator">
        <span>
          {constantes.classificacao.cultura}
        </span>
      </div>
      <div className="inputs-agrupamento-sericicultura">
        <label id="label-cultura" className="cultura">
          <span>
            Cultura
          </span>
          <input
            type="text"
            id="cultura"
            name="cultura"
            placeholder="ex. Café, Tabaco, etc..."
            value={input.cultura}
            onChange={(e) => setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })))}
          />
        </label>
        <label id="label-certificadoraCultura" className="culturaManejo">
          <span>
            Manejo
          </span>
          <input
            type="text"
            id="culturaManejo"
            name="culturaManejo"
            placeholder="ex. convencional, orgânico, biodinâmico"
            value={input.culturaManejo}
            onChange={(e) => setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })))}
          />
        </label>
        <label id="label-culturaCertificada" className="culturaCertificada">
          <span>
            Certificada
          </span>
          <select
            className="form-control"
            name="culturaCertificada"
            id="culturaCertificada"
            onChange={(e) => {
              setInputsVerificacao((prevState) => ({
                ...prevState,
                culturaCertificada: !prevState.culturaCertificada,
              }));
              setarInformacoes(e, setInput((prevState) => ({
                ...prevState, [`${e.target.name}`]: e.target.value,
              })));
            }}
          >
            <option selected={!culturaCertificada} value="Sim">Sim</option>
            <option selected={culturaCertificada} value="Não">Não</option>
          </select>
        </label>
        <label id="label-certificadoraCultura" className="certificadoraCultura">
          <span>
            Certificadora
          </span>
          <input
            type="text"
            id="certificadoraCultura"
            name="certificadoraCultura"
            placeholder="ex. IBD, AAO"
            value={input.certificadoraCultura}
            disabled={culturaCertificada}
            onChange={(e) => setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })))}
          />
        </label>
        <label id="label-tipo" className="possuiCodigoCultura">
          <span>
            Possui Código?
          </span>
          <select
            className="form-control"
            name="possuiCodigoCultura"
            id="possuiCodigoCultura"
            disabled={culturaCertificada}
            onChange={(e) => setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })))}
          >
            <option selected={culturaCertificada} value="Sim">Sim</option>
            <option value="Em Processo de Certificação">Em Processo de Certificação</option>
          </select>
        </label>
        <label id="label-certificadoraCultura" className="codcertificadoraCultura">
          <span>
            Código
          </span>
          <input
            type="text"
            id="codcertificadoraCultura"
            name="codcertificadoraCultura"
            placeholder="ex. IBD, AAO"
            value={input.codcertificadoraCultura}
            disabled={culturaCertificada}
            onChange={(e) => setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })))}
          />
        </label>
        <label id="id-input-agrupamento" htmlFor="id-input-agrupamento">
          <span>Importar KML</span>
          <input
            name="kml"
            type="file"
            onChange={() => {}}
          />
        </label>
        <button
          id="selecionar-mapa"
          type="button"
          data-dismiss="modal"
        >
          <span>
            Seleciona no Mapa
          </span>
        </button>
        <button
          onClick={() => {
            if (temp.positions.length > 2) {
              verificaCultura();
            } else {
              notify('warning', 'Ops!!!, você náo informou a área no mapa, revise.');
            }
          }}
          id="salvar-button"
          type="button"
        >
          <span>
            Salvar Dados
          </span>
        </button>
      </div>
    </div>
  );
}

export default Cultura;
